import { Custom } from '@app/shared/dynamic-form';
import { Injectable } from '@angular/core';
import { BaseControl, Textbox } from '@app/shared';
import { Validators } from '@angular/forms';

@Injectable()
export class StageDetailViewFormService {
  constructor() { }
  getFormStageDetailView(stageViewDetail?: any): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Textbox({
        key: 'txtFin',
        type: 'checkbox',
        value: stageViewDetail && stageViewDetail.fin ? stageViewDetail.fin : false,
        label: '¿Finaliza la etapa?',
        order: 1
      }),
    ];
    return controls.sort((a, b) => a.order - b.order);
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/management-automation/time-control/tramit-stages/stage-detail-view/shared/stage-detail-view.form.service.ts